/**
 * 미저장 변경사항이 있을 때 페이지 이탈(탭 닫기/새로고침)을 경고로 차단한다.
 *
 * 현재 IXD/DSD compare 편집은 같은 URL 안에서 chunk를 전환하는 구조라,
 * SPA 내부 이동보다 실제 페이지 이탈 방지가 우선이다.
 */

import { useEffect } from "react";

export const useUnsavedChangesGuard = (hasUnsavedChanges: boolean): void => {
  useEffect(() => {
    if (!hasUnsavedChanges) return;

    const handler = (event: BeforeUnloadEvent) => {
      // 최신 브라우저는 메시지 텍스트를 무시하고 자체 안내 문구를 띄움.
      // returnValue 설정만으로 prompt가 뜬다.
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [hasUnsavedChanges]);
};
